import {Typography} from '@mui/material';

export const ItemTitle = ({title}: {title: string}) => {
    return (
        <Typography
            variant='body2'
            color='text.secondary'
        >
            {title}
        </Typography>
    );
};
